export const RoutesMap = {
    "/home":"首页",
    "/goods/m" :"商品管理",
    "/users/m" : "会员管理",
    "/order/m" : "订单管理",
	"/pledge/m" : "押金管理",
    "/data/m" : "数据管理",
    "/power/m" : "权限管理",
    "/admin/l" : "管理员列表",
    "/distribute/m" : "分销管理",
    "/distribute/a" : "分销申请",
    "/distribute/l" : "分销级别",
    "/distribute/s" : "分佣比例",
    "/work/m" : "人员管理",
    "/add/g" : "添加商品",
    "/modify/g":"修改商品属性",
    "/divide/s":"商城管理",
    "/house/s":"房源管理",
    "/classify/m":"分类管理",
    "/staff/m":"员工管理",
    "/good/d":"商品详情",
    "/shop/g":"营销组管理",
    "/setting/order":"工单设置",
    "/operators/m":"运营商管理",
    "/downfile":"下载中心",
	"/city/m":"城市管理",
	"/qr/m":"二维码生成",
	"/qr/detail":"二维码查看",
	"/qr/list":"二维码管理"
}
